module.exports = __webpack_public_path__ + "img/icon_xianjin@2x.b9c2d33c.png";